import React, { useState } from "react";
import ShowClientBusinesses from "./ShowClientBusinesses";
import ActionButtons from "../../../../../utils/ActionButtons";
import "../../../../../css/pages/ca_pages/models/ClientsTable.css";

const ClientsTable = ({ clients, onView, onAddBusiness, onFileUpload }) => {
    const [expandedClientId, setExpandedClientId] = useState(null);
    const toggleBusinessView = (clientId) => {
        setExpandedClientId(prev => prev === clientId ? null : clientId );
    };

    // const handleViewBusiness = (clientId) => { onView(clientId); };

    const dropDownOptions = (client) => ([
        { label: "View Client Info", onClick: () => { onView(client.id) } },
        { label: "Add New Business", onClick: () => { onAddBusiness(client) } },
    ]);

    return (
        <div className="clients-table-wrapper">
            <table className="clients-table">
                <thead>
                    <tr>
                        <th>Client Name</th>
                        <th>Email</th>
                        <th>Contact</th>
                        <th>Joined</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {clients.length > 0 ? (
                        clients.map((client) => (
                            <React.Fragment key={client.id}>
                                {/* Client row */}
                                <tr>
                                    <td>
                                        <div className="client-info">
                                            <img
                                                src={
                                                    client.user_profile_image ||
                                                    `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                                        client.user_full_name
                                                    )}`
                                                }
                                                alt={client.user_full_name}
                                                className="client-avatar"
                                            />

                                            <div>
                                                <p className="client-name">
                                                    {client.user_full_name}
                                                </p>
                                                <p className="client-id">
                                                    ID: {client.id}
                                                </p>
                                            </div>
                                        </div>
                                    </td>

                                    <td>{client.email}</td>

                                    <td>{client.contact}</td>

                                    <td>
                                        {new Date(
                                            client.created_at
                                        ).toLocaleDateString()}
                                    </td>

                                    <td>
                                        <div className="table-actions">
                                            <ActionButtons
                                                actions={[
                                                    {
                                                        buttonType: "view",
                                                        customName:
                                                            expandedClientId === client.id
                                                                ? "Hide Business"
                                                                : "View Business",
                                                        onClick: () => toggleBusinessView(client.id),
                                                    },
                                                    {
                                                        buttonType: "moreOptions",
                                                        dropdownOptions: dropDownOptions(client)
                                                    }
                                                ]}
                                            />
                                        </div>
                                    </td>
                                </tr>

                                {/* Expanded row for business information */}
                                {expandedClientId === client.id && (
                                    <tr>
                                        <td colSpan="5">
                                            <ShowClientBusinesses
                                                clientId = { client.id }
                                                onSubmit = { onFileUpload }
                                            />
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" className="no-data">
                                No clients found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ClientsTable;
